import { formatDate, mString } from 'lib/helpers/utility';

import QuotesPopover from '../components/QuotesPopover';

export const getColDefs = () => {
  return [
    { headerName: 'Name', field: 'name' },
    {
      headerName: 'Created date',
      field: 'created_at',
      valueGetter: ({ data }) => {
        return formatDate(data.created_at);
      }
    },
    {
      headerName: 'Total payment',
      field: 'id',
      valueGetter: ({ data }) => mString(data.total_amount - data.amount_paid)
    },
    {
      field: 'actions',
      headerName: '',
      maxWidth: 100,
      minWidth: 100,
      resizable: false,
      cellRenderer: QuotesPopover
    }
  ];
};
